import { components, OptionProps } from 'react-select'
import Tooltip from '@material-ui/core/Tooltip'

const CustomOption = (props: OptionProps<any, true>) => (
	<components.Option {...props}>
		<Tooltip placement='bottom' title={props.data.label}>
			<>
				<span
					style={{
						fontSize: '12px',
						padding: '0 4px',
						backgroundColor: props.data.color,
						borderRadius: '4px',
						display: 'inline-block',
						color: '#000' // Adjust for better contrast
					}}
				>
					{props.data.label}
				</span>
			</>
		</Tooltip>
	</components.Option>
)

export default CustomOption
